import type { DeploymentProfile, SidebarMenuKey } from './deployment.types'
import { matchPath } from 'react-router-dom'

export const SIDEBAR_MENU_PATHS: Partial<Record<SidebarMenuKey, string>> = {
  dashboard: '/dashboard',
  agents: '/agents',
  applications: '/applications',
  channels: '/channels',
  'channel-accounts': '/channel-accounts',
  credentials: '/credentials',
  sandboxes: '/plugins/sandboxes',
  mcps: '/plugins/mcps',
  memories: '/plugins/memories',
  models: '/plugins/models',
  'rags-build': '/plugins/rags/build',
  'rags-catalog': '/plugins/rags/catalog',
  skillgroups: '/plugins/skills',
  'skills-management': '/plugins/skills/management',
  'skills-plaza': '/plugins/skills/plaza',
  'iam-users': '/iam/users',
  'iam-groups': '/iam/groups',
  'iam-policies': '/iam/policies',
  'iam-grants': '/iam/grants'
}

export function isSidebarMenuVisible(profile: DeploymentProfile, menuId: string): boolean {
  const visibleItems = profile.navigation.sidebar.visibleItems
  return visibleItems === undefined || visibleItems.includes(menuId as SidebarMenuKey)
}

export function getSidebarDefaultPath(profile: DeploymentProfile): string {
  const { defaultItem, visibleItems } = profile.navigation.sidebar
  const configuredDefault = defaultItem ? SIDEBAR_MENU_PATHS[defaultItem] : undefined
  if (defaultItem && configuredDefault && isSidebarMenuVisible(profile, defaultItem)) {
    return configuredDefault
  }

  const firstVisiblePath = visibleItems
    ?.map(item => SIDEBAR_MENU_PATHS[item])
    .find((path): path is string => Boolean(path))

  return firstVisiblePath ?? '/dashboard'
}

export function isDeploymentRouteDisabled(profile: DeploymentProfile, pathname: string): boolean {
  return (profile.navigation.routes.disabledPatterns ?? []).some(pattern =>
    Boolean(matchPath({ path: pattern, end: false }, pathname))
  )
}
